import { Language } from '../../../enums/const-enums';

export interface CodeTranslations {
  messageTitle?: string;
  message?: string;
  buttonLabel?: string;
  logoutButtonLabel?: string;
  malwareLimitSigningButtonLabel?: string;
}

export interface RassOverlayTranslations {
  codes: {
    [code: string]: CodeTranslations;
  };
  default: CodeTranslations;
}

const nlTranslations: RassOverlayTranslations = {
  codes: {
    '02999': {
      message:
        'Oeps, er is iets misgegaan. We werken eraan om het te repareren. Probeer het later opnieuw.',
    },
    '02990': {
      message:
        'We konden je account niet verifiëren. Probeer opnieuw in te loggen vanaf de site die u wilt bezoeken.',
    },
    '02995': {
      message:
        'Het lijkt erop dat je sessie is beëindigd. Log opnieuw in om door te gaan.',
    },
    '03101': {
      message:
        'Onjuiste gebruikersnaam of wachtwoord. Wees voorzichtig, te veel mislukte pogingen zullen je account tijdelijk vergrendelen.',
    },
    '03111': {
      message:
        'Er is een probleem opgetreden bij het inloggen met e-mailadres en wachtwoord. Als het probleem blijft optreden, neem dan contact op met de Rabobank voor ondersteuning.',
    },
    '03994': {
      message:
        'Er is een probleem opgetreden bij het inloggen met e-mailadres en wachtwoord. Als het probleem blijft optreden, neem dan contact op met de Rabobank voor ondersteuning.',
    },
    '03995': {
      message:
        'Er is een probleem opgetreden bij het inloggen met e-mailadres en wachtwoord. Als het probleem blijft optreden, neem dan contact op met de Rabobank voor ondersteuning.',
    },
    '03999': {
      message:
        'Oeps, er is iets misgegaan. We werken eraan om het te repareren. Probeer het later opnieuw.',
    },

    '00703': {
      message:
        'Er is een probleem opgetreden bij het inloggen. Blijft het probleem zich voordoen, neem dan contact op met de Rabobank voor ondersteuning.',
    },
    '00704': {
      message:
        'Er is een probleem opgetreden bij het inloggen. Blijft het probleem zich voordoen, neem dan contact op met de Rabobank voor ondersteuning.',
    },
    '00705': {
      message:
        'Er is een probleem opgetreden bij het inloggen. Blijft het probleem zich voordoen, neem dan contact op met de Rabobank voor ondersteuning.',
    },
    '00706': {
      messageTitle: 'We hebben overal gezocht..',
      message: 'Maar we kunnen die pagina niet vinden.',
      buttonLabel: 'Terug',
    },
    '00710': {
      message: 'Gebruiker kan niet worden geauthenticeerd',
    },
    '00715': {
      message:
        'Het lijkt erop dat je al bent ingelogd. Je kunt weer terug naar de website die je bezocht, of je kiest om uit te loggen.',
      buttonLabel: 'Doorgaan',
    },
    '00801': {
      message: `We zien dat je malware op je telefoon hebt. Deze opdracht kan je ondertekenen, maar om misbruik te voorkomen 
        kan je geen risicovolle opdrachten ondertekenen totdat je de malware van je telefoon verwijderd hebt. Je kan 
        tot die tijd wel op een computer internetbankieren: inloggen en tekenen met de QR-code blijft werken, ook voor 
        risicovolle opdrachten.<br><br>Kijk voor meer informatie op 
        <a target=_blank href="https://www.rabobank.nl/malware">www.rabobank.nl/malware</a>`,
    },
    '00802': {
      message: `We zien dat je malware op je telefoon hebt. Deze opdracht kan je ondertekenen zoals je gewend bent, maar om 
        misbruik te voorkomen kan je risicovolle opdrachten in de app alleen ondertekenen met de Rabo Scanner, totdat 
        je de malware van je telefoon verwijderd hebt. Je kan tot die tijd wel op een computer internetbankieren zonder 
        Rabo Scanner: inloggen en tekenen met de QR-code blijft werken, ook voor risicovolle opdrachten.<br><br>Kijk 
        voor meer informatie op <a target=_blank href="https://www.rabobank.nl/malware">www.rabobank.nl/malware</a>`,
    },
    '00803': {
      message: `We zien dat je malware op je telefoon hebt. Om misbruik te voorkomen kan je in je app risicovolle opdrachten 
        (zoals deze opdracht) alleen ondertekenen met de Rabo Scanner, totdat je de malware van je telefoon verwijderd 
        hebt. Je kan nog wel op een computer internetbankieren zonder Rabo Scanner: inloggen en tekenen met de QR-code 
        blijft werken.<br><br>Kijk voor meer informatie op 
        <a target=_blank href="https://www.rabobank.nl/malware">www.rabobank.nl/malware</a>`,
    },
  },
  default: {
    message:
      'Er is een probleem opgetreden met je aanmelding. Blijft het probleem zich voordoen, neem dan contact op met de Rabobank voor ondersteuning.',
    buttonLabel: 'Annuleren',
    logoutButtonLabel: 'Uitloggen',
    malwareLimitSigningButtonLabel: 'Begrepen',
  },
};

const enTranslations: RassOverlayTranslations = {
  codes: {
    '02999': {
      message:
        "Oops, something went wrong. We're working to fix it. Please try again later.",
    },
    '02990': {
      message:
        'Authentication error. Please return to the login page of the site you want to access.',
    },
    '02995': {
      message:
        'It looks like your session has ended, Please log in again to continue.',
    },
    '03101': {
      message:
        'Incorrect username or password. Be careful, too many failed attempts will lock your account temporarily.',
    },
    '03111': {
      message:
        'There was a problem while trying to login with email and password. If it keeps happening, please contact Rabobank for support.',
    },
    '03994': {
      message:
        'There was a problem while trying to login with email and password. If it keeps happening, please contact Rabobank for support.',
    },
    '03995': {
      message:
        'There was a problem while trying to login with email and password. If it keeps happening, please contact Rabobank for support.',
    },
    '03999': {
      message:
        "Oops, something went wrong. We're working to fix it. Please try again later.",
    },
    '00703': {
      message:
        'There was a problem with your login. If it keeps happening, please contact Rabobank for support.',
    },
    '00704': {
      message:
        'There was a problem with your login. If it keeps happening, please contact Rabobank for support.',
    },
    '00705': {
      message:
        'There was a problem with your login. If it keeps happening, please contact Rabobank for support.',
    },
    '00706': {
      messageTitle: 'We looked everywhere..',
      message: 'But could not find that page.',
      buttonLabel: 'Back',
    },
    '00710': {
      message: 'User cannot be authenticated',
    },
    '00715': {
      message:
        "It looks like you're already logged on. You can continue from where you left off or choose to log out.",
      buttonLabel: 'Continue',
    },
    '00801': {
      message: `We see that you have malware on your phone. You can sign this transaction, but to prevent misuse, 
        you cannot sign risky transactions until you remove the malware from your phone. In the meantime, 
        you can use online banking on a computer: logging in and signing with the QR code will still work, 
        even for risky transactions.<br><br>For more information, visit 
        <a target=_blank href="https://www.rabobank.nl/malware">www.rabobank.nl/malware</a>`,
    },
    '00802': {
      message: `We see that you have malware on your phone. You can sign this transaction as usual, but to prevent 
        misuse, you can only sign risky transactions in the app with the Rabo Scanner until you remove the 
        malware from your phone. In the meantime, you can use online banking on a computer without the Rabo 
        Scanner: logging in and signing with the QR code will still work, even for risky transactions.<br><br>
        For more information, visit <a target=_blank href="https://www.rabobank.nl/malware">www.rabobank.nl/malware</a>`,
    },
    '00803': {
      message: `We see that you have malware on your phone. To prevent misuse, you can only sign risky transactions 
        (like this one) in your app with the Rabo Scanner until you remove the malware from your phone. You 
        can still use online banking on a computer without the Rabo Scanner: logging in and signing with the 
        QR code will still work.<br><br>For more information, visit 
        <a target=_blank href="https://www.rabobank.nl/malware">www.rabobank.nl/malware</a>`,
    },
  },
  default: {
    message:
      'There was a problem with your login. If it keeps happening, please contact Rabobank for support.',
    buttonLabel: 'Cancel',
    logoutButtonLabel: 'Logout',
    malwareLimitSigningButtonLabel: 'Understood',
  },
};

const ptTranslations: RassOverlayTranslations = {
  codes: {
    '02999': {
      message:
        'Ops, algo deu errado. Estamos trabalhando para consertar isso. Por favor, tente novamente mais tarde.',
    },
    '02990': {
      message:
        'Erro de autenticação. Por favor, retorne à página de login do site que você deseja acessar.',
    },
    '02995': {
      message:
        'Parece que sua sessão terminou. Faça login novamente para continuar.',
    },
    '03101': {
      message:
        'Nome de usuário ou senha incorretos. Tenha cuidado, muitas tentativas fracassadas bloquearão sua conta temporariamente.',
    },
    '03111': {
      message:
        'Ocorreu um problema ao tentar fazer login com e-mail e senha. Se isso continuar acontecendo, entre em contato com o Rabobank para obter suporte.',
    },
    '03994': {
      message:
        'Ocorreu um problema ao tentar fazer login com e-mail e senha. Se isso continuar acontecendo, entre em contato com o Rabobank para obter suporte.',
    },
    '03995': {
      message:
        'Ocorreu um problema ao tentar fazer login com e-mail e senha. Se isso continuar acontecendo, entre em contato com o Rabobank para obter suporte.',
    },
    '03999': {
      message:
        'Opa, algo deu errado. Estamos trabalhando para consertar isso. Por favor, tente novamente mais tarde.',
    },
    '00703': {
      message:
        'Houve um problema com seu login. Se isso continuar acontecendo, entre em contato com o Rabobank para obter suporte.',
    },
    '00704': {
      message:
        'Houve um problema com seu login. Se isso continuar acontecendo, entre em contato com o Rabobank para obter suporte.',
    },
    '00705': {
      message:
        'Houve um problema com seu login. Se isso continuar acontecendo, entre em contato com o Rabobank para obter suporte.',
    },
    '00706': {
      messageTitle: 'Procuramos em todos os lugares..',
      message: 'Mas não foi possível encontrar essa página.',
      buttonLabel: 'Voltar',
    },
    '00710': {
      message: 'Usuário não pode ser autenticado',
    },
    '00715': {
      message:
        'Parece que você já está conectado. Você pode voltar para onde você estava ou fazer logout.',
      buttonLabel: 'Continuar',
      logoutButtonLabel: 'Voltar',
    },
    '00801': {
      message: `Observamos que tienes malware en tu teléfono. Puedes firmar esta transacción, 
      pero para evitar el uso indebido, no podrás firmar transacciones de riesgo hasta que 
      elimines el malware de tu teléfono. Mientras tanto, puedes usar la banca en línea desde 
      una computadora: iniciar sesión y firmar con el código QR seguirá funcionando, 
      incluso para transacciones de riesgo.<br><br>Para obtener más información, visite 
        <a target=_blank href="https://www.rabobank.nl/malware">www.rabobank.nl/malware</a>`,
    },
    '00802': {
      message: `Observamos que tienes malware en tu teléfono. Puedes firmar esta transacción como siempre, pero para evitar un 
      uso indebido, solo puedes firmar transacciones de riesgo en la app con el Rabo Scanner hasta que elimines el malware de 
      tu teléfono. Mientras tanto, puedes usar la banca en línea en una computadora sin el Rabo Scanner: iniciar sesión y 
      firmar con el código QR seguirá funcionando, incluso para transacciones de riesgo.
      <br><br>Para obtener más información, visite <a target=_blank href="https://www.rabobank.nl/malware">www.rabobank.nl/malware</a>`,
    },
    '00803': {
      message: `Observamos que tienes malware en tu teléfono. Para evitar el uso indebido, solo puedes firmar transacciones de 
      riesgo (como esta) en tu app con el Rabo Scanner hasta que elimines el malware de tu teléfono. Puedes seguir usando la banca 
      en línea en una computadora sin el Rabo Scanner: iniciar sesión y firmar con el código QR seguirá funcionando.
      <br><br>Para obtener más información, visite <a target=_blank href="https://www.rabobank.nl/malware">www.rabobank.nl/malware</a>`,
    },
  },
  default: {
    message:
      'Hubo un problema con tu inicio de sesión. Si esto continúa sucediendo, comuníquese con Rabobank para obtener ayuda.',
    buttonLabel: 'Cancelar',
    logoutButtonLabel: 'Voltar',
    malwareLimitSigningButtonLabel: 'Comprendida',
  },
};

export const rassOverlayTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: enTranslations,
  [Language.PT]: ptTranslations,
};
